import { MainLayout } from './components';
import { AboutUsPage, CategoryCoursesPage, ContactPage, CourseDetailPage, FreeCoursesPage, HomePage, NewCoursesPage, PlaylistPage, PolicyPage, PricingPage, ProfilePage, TeacherPage } from './pages';
import ProfileDetailsPage from './pages/Profile/ProfileDetailsPage';
import ProfileFavoritesPage from './pages/Profile/ProfileFavoritesPage';
import ProfileHelpPage from './pages/Profile/ProfileHelpPage';
import ProfilePlanPage from './pages/Profile/ProfilePlanPage';
import ProfileProgressPage from './pages/Profile/ProfileProgressPage';
import { AuthProvider } from './context/AuthContext';
import { ProfileProvider } from './context/ProfileContext';
import { SubscriptionProvider } from './context/SubscriptionContext';
import AuthPopup from './components/common/AuthPopup/AuthPopup';
import GlobalToast from './components/common/GlobalToast';
import SessionExpiredListener from './components/common/SessionExpiredListener';
import ScrollToTop from './components/common/ScrollToTop';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <SubscriptionProvider>
          <BrowserRouter>
            <ScrollToTop />
            <SessionExpiredListener />
            <MainLayout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/price" element={<PricingPage />} />
                <Route path="/courses/free" element={<FreeCoursesPage />} />
                <Route path="/courses/browse" element={<CategoryCoursesPage />} />
                <Route path="/courses/new" element={<NewCoursesPage />} />
                <Route path="/courses/:courseId" element={<CourseDetailPage />} />
                <Route path="/courses/:courseId/play" element={<PlaylistPage />} />
                <Route path="/teachers/:teacherId" element={<TeacherPage />} />
                <Route path="/about-us" element={<AboutUsPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/policies/:type" element={<PolicyPage />} />
                <Route path="/profile" element={<ProfilePage />}>
                  <Route index element={<ProfileDetailsPage />} />
                  <Route path="plan" element={<ProfilePlanPage />} />
                  <Route path="progress" element={<ProfileProgressPage />} />
                  <Route path="favorites" element={<ProfileFavoritesPage />} />
                  <Route path="help" element={<ProfileHelpPage />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <AuthPopup />
              <GlobalToast />
            </MainLayout>
          </BrowserRouter>
        </SubscriptionProvider>
      </ProfileProvider>
    </AuthProvider>
  );
}

export default App;
